// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuPlaceholder{--vuuView-justify:center;flex:1 1 0;align-items:center;display:flex}.vuuPlaceholder-nested{background-color:red}.vuuPlaceholder-shim{flex-grow:0;flex-shrink:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
